import React from 'react'

export const Folder = (): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="215.7"
    height="21.559"
    viewBox="0 0 215.7 21.559"
  >
    <g
      id="Group_415"
      data-name="Group 415"
      transform="translate(338.592 178.262)"
    >
      <path
        id="Path_819"
        data-name="Path 819"
        d="M-145.306-157.953l.348.079,2.587.471,2.586.261,3.536.157,3.536-.1,3.536-.262,3.554-.5a3.337,3.337,0,0,0,2.047-1.377,2.056,2.056,0,0,0,.329-1.888l0-.018a23.843,23.843,0,0,0-5.713-6.889l-2.323-1.621-2.428-1.465-2.533-1.255-2.639-1.151-2.639-.941-2.744-.784-2.745-.576-2.85-.418-6.228-.68-6.228-.523-6.228-.314-6.281-.1h-6.228l-6.228.209-5.436.314a10.828,10.828,0,0,0-2.555,5.186,13.132,13.132,0,0,0,.487,5.67,40.761,40.761,0,0,0,3.883,6.441l3.23-.007a9.632,9.632,0,0,1,1.481-1.311l1.5.181,8.128.994,8.18.784,8.181.628,8.253.464C-149.743-158.138-145.306-157.953-145.306-157.953Z"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_820"
        data-name="Path 820"
        d="M-280.344-177.494l-8.189.74-8.188.9-8.136,1.056-8.136,1.215-5.125.793-5.124.951-5.072,1.109-5.019,1.268-5.019,1.48a25.644,25.644,0,0,0,11.965,6.692,36.983,36.983,0,0,0,10.7,1.327l5.333-.148,5.283-.317,19.616-1.146a2.4,2.4,0,0,1,1.884-1.018l3.363.088h0q.793,1.272,1.679,2.485l3.255.067a9.7,9.7,0,0,1,11.753-2.058,4.139,4.139,0,0,0,3.923.314,11.513,11.513,0,0,1,5.524-1.15,35.784,35.784,0,0,1,5.6.522l2.837.575,2.852.687,2.8.9,2.431.951,2.536.793,2.535.581,2.536.475,2.589.265,3.54.158,3.539-.106,3.54-.264,3.539-.475A3.219,3.219,0,0,0-211-159.309a2.083,2.083,0,0,0,.237-1.8,24.14,24.14,0,0,0-5.682-7.018,42.6,42.6,0,0,0-20.9-8.273l-6.278-.667-6.234-.529-6.287-.317-6.234-.1h-6.286l-6.234.211-5.442.317"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_821"
        data-name="Path 821"
        d="M-166.544-162.79l2.85.157,2.745.366,2.9.523,2.85.68,2.8.889,2.428.941,2.481.784,2.185.5"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_822"
        data-name="Path 822"
        d="M-323.115-171.9a42.188,42.188,0,0,0,12.509,1.4l21.227-1.634a3.2,3.2,0,0,1,3.491,2.368l2.269,7.169"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_823"
        data-name="Path 823"
        d="M-274-169.754a1.453,1.453,0,0,0-1.453-1.453,1.452,1.452,0,0,0-1.453,1.453,1.454,1.454,0,0,0,1.453,1.453A1.454,1.454,0,0,0-274-169.754"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_824"
        data-name="Path 824"
        d="M-298.148-173.717a.924.924,0,0,0-.924-.924.925.925,0,0,0-.925.924.925.925,0,0,0,.925.925.925.925,0,0,0,.924-.925"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_825"
        data-name="Path 825"
        d="M-298.465-173.717a.607.607,0,0,0-.607-.607.608.608,0,0,0-.608.607.608.608,0,0,0,.608.608.608.608,0,0,0,.607-.608"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_826"
        data-name="Path 826"
        d="M-245.529-175.671a.608.608,0,0,0-.607-.608.608.608,0,0,0-.608.608.608.608,0,0,0,.608.607.607.607,0,0,0,.607-.607"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_827"
        data-name="Path 827"
        d="M-213.408-163.256a.608.608,0,0,0-.607-.608.608.608,0,0,0-.608.608.608.608,0,0,0,.608.607.607.607,0,0,0,.607-.607"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_828"
        data-name="Path 828"
        d="M-229.046-172.871a.608.608,0,0,0-.607-.608.608.608,0,0,0-.608.608.608.608,0,0,0,.608.607.607.607,0,0,0,.607-.607"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_829"
        data-name="Path 829"
        d="M-269.989-175.566a.607.607,0,0,0-.608-.607.607.607,0,0,0-.607.607.608.608,0,0,0,.607.608.608.608,0,0,0,.608-.608"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_830"
        data-name="Path 830"
        d="M-274.585-169.754a.872.872,0,0,0-.872-.872.872.872,0,0,0-.872.872.871.871,0,0,0,.872.871.872.872,0,0,0,.872-.871"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_831"
        data-name="Path 831"
        d="M-245.529-175.671a.608.608,0,0,0-.607-.608.608.608,0,0,0-.608.608.608.608,0,0,0,.608.607.607.607,0,0,0,.607-.607"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_832"
        data-name="Path 832"
        d="M-213.408-163.2a.608.608,0,0,0-.607-.608.608.608,0,0,0-.608.608.608.608,0,0,0,.608.607.607.607,0,0,0,.607-.607"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_833"
        data-name="Path 833"
        d="M-228.993-172.818a.608.608,0,0,0-.607-.608.608.608,0,0,0-.608.608.608.608,0,0,0,.608.607.607.607,0,0,0,.607-.607"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_834"
        data-name="Path 834"
        d="M-212.246-158.1l-1.045-1.691a31.08,31.08,0,0,0-9.659-8.315,39.647,39.647,0,0,0-10.85-3.836l-8.876-1.479-8.972-1.288a4.573,4.573,0,0,0-2.9-1.673l-7.786-.209-7.8-.051a1.3,1.3,0,0,0-1.152.841"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_835"
        data-name="Path 835"
        d="M-274.585-169.754a.872.872,0,0,0-.872-.872.872.872,0,0,0-.872.872.871.871,0,0,0,.872.871.872.872,0,0,0,.872-.871"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_836"
        data-name="Path 836"
        d="M-280.288-177.472a10.919,10.919,0,0,0-2.561,5.217,13.407,13.407,0,0,0,.466,5.732,40.837,40.837,0,0,0,2.177,4.017l.6.016v-.581a.645.645,0,0,1,.475-.581l7.291-.846a6.406,6.406,0,0,0,2.746-6.084,6.418,6.418,0,0,0-4.186-5.21l-4.847.147-.053-1.953"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_837"
        data-name="Path 837"
        d="M-178.441-174.96a2.416,2.416,0,0,0,2.052-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_535"
        data-name="Line 535"
        x1="3.853"
        y1="0.889"
        transform="translate(-182.325 -175.813)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_838"
        data-name="Path 838"
        d="M-125.772-157.827l-1.663-2.505-1.478-1.726-1.689-1.569-1.794-1.464-1.9-1.255-2.058-1.1-2.428-1.151-2.533-.941-2.586-.785-2.639-.575-5.225-.941-5.278-.785-19.317-2.876"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_536"
        data-name="Line 536"
        x2="0.844"
        y2="7.427"
        transform="translate(-178.472 -174.924)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_839"
        data-name="Path 839"
        d="M-177.625-167.483a3.178,3.178,0,0,0,2.924,3.008"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_840"
        data-name="Path 840"
        d="M-174.725-164.464l21.059,2.72,3.114.628,3.008.889,2.956,1.1,4.2,1.926"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_841"
        data-name="Path 841"
        d="M-189.261-169.965a1.44,1.44,0,0,0,1.12,1.705,1.451,1.451,0,0,0,1.72-1.11,1.438,1.438,0,0,0-1.12-1.705,1.452,1.452,0,0,0-1.72,1.11"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_842"
        data-name="Path 842"
        d="M-191.245-164.254l4.75.837-.369,1.987.667.081"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_537"
        data-name="Line 537"
        x1="7.336"
        y1="0.68"
        transform="translate(-190.348 -175.499)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_843"
        data-name="Path 843"
        d="M-183.024-174.819a.607.607,0,0,0,.572-.442"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_538"
        data-name="Line 538"
        y1="0.575"
        x2="0.106"
        transform="translate(-182.431 -175.813)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_844"
        data-name="Path 844"
        d="M-166.472-161.175a.916.916,0,0,0,.713,1.085.925.925,0,0,0,1.1-.707.915.915,0,0,0-.713-1.084.924.924,0,0,0-1.1.706"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_845"
        data-name="Path 845"
        d="M-166.162-161.11a.6.6,0,0,0,.469.713.607.607,0,0,0,.719-.464.6.6,0,0,0-.468-.713.608.608,0,0,0-.72.464"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_846"
        data-name="Path 846"
        d="M-190.319-175.528a6.357,6.357,0,0,0-3.914,5.36,6.334,6.334,0,0,0,3.015,5.9"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_847"
        data-name="Path 847"
        d="M-157.941-175.525a.6.6,0,0,0-.607-.6.6.6,0,0,0-.607.6.6.6,0,0,0,.607.6.6.6,0,0,0,.607-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_848"
        data-name="Path 848"
        d="M-125.851-163.235a.6.6,0,0,0-.607-.6.6.6,0,0,0-.607.6.6.6,0,0,0,.607.6.6.6,0,0,0,.607-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_849"
        data-name="Path 849"
        d="M-141.474-172.753a.6.6,0,0,0-.607-.6.6.6,0,0,0-.607.6.6.6,0,0,0,.607.6.6.6,0,0,0,.607-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_850"
        data-name="Path 850"
        d="M-166.477-162.831a11.671,11.671,0,0,0-5.539,1.124"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_851"
        data-name="Path 851"
        d="M-175.949-161.962a4.122,4.122,0,0,0,3.9.269"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_852"
        data-name="Path 852"
        d="M-175.967-162a9.709,9.709,0,0,0-10.23.653"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_853"
        data-name="Path 853"
        d="M-123.418-159.467a2.047,2.047,0,0,0,.152-1.646"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_854"
        data-name="Path 854"
        d="M-182.431-175.42a.6.6,0,0,0-.607-.6.6.6,0,0,0-.607.6.6.6,0,0,0,.607.6.6.6,0,0,0,.607-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_855"
        data-name="Path 855"
        d="M-186.97-169.667a.867.867,0,0,0-.871-.863.867.867,0,0,0-.871.863.867.867,0,0,0,.871.862.867.867,0,0,0,.871-.862"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_856"
        data-name="Path 856"
        d="M-157.941-175.525a.6.6,0,0,0-.607-.6.6.6,0,0,0-.607.6.6.6,0,0,0,.607.6.6.6,0,0,0,.607-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_857"
        data-name="Path 857"
        d="M-125.851-163.182a.6.6,0,0,0-.607-.6.6.6,0,0,0-.607.6.6.6,0,0,0,.607.6.6.6,0,0,0,.607-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_858"
        data-name="Path 858"
        d="M-141.474-172.7a.6.6,0,0,0-.607-.6.6.6,0,0,0-.607.6.6.6,0,0,0,.607.6.6.6,0,0,0,.607-.6"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_859"
        data-name="Path 859"
        d="M-190.556-177.369l.05,1.923,6.809-.209"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_860"
        data-name="Path 860"
        d="M-182.519-176.491a1.29,1.29,0,0,0-1.15.833"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_861"
        data-name="Path 861"
        d="M-166.966-176.179l-7.811-.262-7.811-.052"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_862"
        data-name="Path 862"
        d="M-164.054-174.577a4.577,4.577,0,0,0-2.893-1.656"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_863"
        data-name="Path 863"
        d="M-124.76-158.247l-.985-1.562-1.636-1.935-1.847-1.778-1.9-1.674-2.111-1.517-2.164-1.307-2.586-1.255-2.692-1.046-2.745-.837-2.8-.68-8.92-1.464-8.92-1.255"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_864"
        data-name="Path 864"
        d="M-186.97-169.667a.867.867,0,0,0-.871-.863.867.867,0,0,0-.871.863.867.867,0,0,0,.871.862.867.867,0,0,0,.871-.862"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
    </g>
  </svg>
)
